module.exports = __webpack_public_path__ + "img/smartphone_mount.c512687c.jpg";